export enum NotificationsSlugs {
  CLIENT = 'client',
  CART = 'cart',
  LEAD = 'lead',
  LEAD_HISTORY = 'lead-history',
  LEAD_REMINDER = 'lead_reminder',
  ORDER = 'order',
  ORDER_SIDE_NEW = 'order_side_new',
  ORDER_SIDE_exist = 'order_side_exist',
  REALIZATION = 'realization',
  STAFF = 'staff',
  CERTIFICATION = 'certification',
  CERTIFICATION_OWNER = 'certification_owner',
  ORDER_SIDE_NOT_SIGNED_DOCUMENT_UPLOADED = 'order_side_not_signed_document_uploaded',
  NEWS_PUBLISHED = 'news_published',
  NEWS = 'news',
  EVENT = 'event',
  SOFTWARE_LICENSES = 'software_licenses',
  PATCH_NOTES = 'patch_notes',
  CALENDAR = 'calendar',
  PURCHASE_ORDERS = 'purchase-orders',
  SMART_RADAR = 'smart-radar',
}
